import React from 'react'
import Modal from 'react-modal'
import {Table, Thead, Th, Tr, Td} from 'components/reactable'
import styles from './listSelect.scss'
import underscore from 'underscore'
import i18n from 'lib/i18n'
import uuidv4 from 'uuid/v4'
import InfoModal from './generalComponents/infoModal'

const _ = i18n('clients')

const customStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
        zIndex: 2
    },
    content: {
        position: 'relative',
        top: 'initial',
        bottom: 'initial',
        left: 'initial',
        right: 'initial',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '0',
    },
}

export default class EmailListSelect extends React.Component {
    static propTypes = {
        data: React.PropTypes.array,
        formStatus: React.PropTypes.object,
    }

    constructor(props) {
        super(props)
        this.state = {modalIsOpen: false, informModalOpen: false}
    }

    getIcon() {
        try {
            return require(`resources/images/a-trash_1x_ovbBlue.svg`)
        } catch(err) {
            return require(`resources/images/icn-no-result.svg`)
        }
    }

    openModal() {
        this.setState({modalIsOpen: !this.state.modalIsOpen})
    }
 
    handleAddFieldButton = () => {
        const data = this.props.data

        if (data.length > 0) {
            let isSetDefaultValue = false
            data.map((key, index) => {
                if (key.default.checked == true) {
                    isSetDefaultValue = true
                }
            })

            if (!isSetDefaultValue) {
                data.addField({email: "", default: true, uniqueId: uuidv4()})
            }
            else {
                data.addField({email: "", default: false, uniqueId: uuidv4()})
            }
        }
        else {
            data.addField({email: "", default: true, uniqueId: uuidv4()})
        }
        this.openModal()
    }

    addElementData() {
        this.openModal()
    }

    removeItemFromList( itemUniqueId ) {
        const data = this.props.data

        Object.keys(data).map((dataKey) => {
            if( data[dataKey] && data[dataKey] !== undefined && data[dataKey].uniqueId.value === itemUniqueId ) {
                data.removeField(dataKey)
            }
        })
    }

    removeItem() {
        const data = this.props.data
        data.removeField()
    }

    modalContentPopup() {
        const data = this.props.data

        let lastEmail = data.slice(-1)[0]
        let errorData = true

        if (lastEmail != undefined) {
            if (lastEmail.email.error != undefined) {
                errorData = true
            }
            else {
                errorData = false
            }
        }

        return (
            <div className={styles.clientModalContent}>
                <span className={styles.title}>{_("addEmailAddress")}</span>
                <label>{_('email')}</label>
                { lastEmail != undefined && <input type="text" {...lastEmail.email} /> }

                <div className={ styles.error }> { lastEmail != undefined && lastEmail.email.error && lastEmail.email.touched && lastEmail.email.error } </div>
                <div className={styles.clientModalButtons}>
                    <input
                        onClick={() => {
                            this.openModal()
                            this.removeItem()
                        }}
                        type="button"
                        className={styles.cancel}
                        value={_("cancel")}
                    />
                    <input
                        onClick={() => this.openModal()}
                        type="button"
                        className={styles.next + " " + (!errorData && styles.enabled) }
                        value={_("clientAdd")}
                        disabled={errorData}
                    />
                </div>
            </div>
        )
    }

    /**
     * This will set the form value content in store
     */
     updateFormValue(value, field) {
        const {dispatch} = this.props

        return dispatch({
            type: "redux-form/CHANGE",
            field: field.name,
            value: value && value.value,
            touch: value && value.touched || field.touched,
            form: "clientProfileEdit"
        })
    }

    /**
     *
     * @param {*} uniqueId
     * @param {any}
     * @returns
     */
     async setCheckedAndClearOthers(uniqueId, emailAddresses) {
        let returnValue

        // walk trough all of the phoneNumber fields
        for (let i=0; i<emailAddresses.length; i++) {
            let oneEmailAddress = emailAddresses[i]

            // reset all values
            oneEmailAddress.default.value = false
            oneEmailAddress.default.checked = false

            // check if this is the selected radio button
            let isThisTheSelectedField = oneEmailAddress.uniqueId.value === uniqueId.value

            // overwrite the selected value to checked
            if (isThisTheSelectedField) {
                oneEmailAddress.default.value = true
                oneEmailAddress.default.checked = true
            }

            // update redux form
            let formChangeResult = await this.updateFormValue(oneEmailAddress.default, oneEmailAddress.default)

            // keep the actual filed changing return value for the input
            if (isThisTheSelectedField) {
                returnValue = formChangeResult
            }

        }

        return returnValue
    }

    render() {
        const {data, formStatus} = this.props
        const {informModalOpen, modalIsOpen} = this.state
        let isSetDefaultValue = false

        const newData = data.map((item, key) => {
            delete item.default.value
            if (item.default.checked == true) {
                isSetDefaultValue = true
            }

            return item
        })

        return (
            <div className={styles.moduleSection}>
                <div className={styles.clientsTableContainer}>
                    {!underscore.isEmpty(newData) && underscore.isArray(newData) && (newData[0] !== 'Too many rows') &&
                    <Table
                        className={styles.table}
                        itemsPerPage={50}
                        topPagination=""
                        filterable={[]}
                        sortable={[
                            "email.value",
                        ]}
                        defaultSort={{
                            column: 'email.value',
                            direction: 'asc',
                        }}
                    >
                        <Thead>
                        <Th column="email.value">
                            <strong>{_('email')}</strong>
                        </Th>
                        <Th column="default.value">
                            <strong>{_('default')}</strong>
                        </Th>
                        <Th column="checkEmail">
                            <strong></strong>
                        </Th>
                        </Thead>
                        { newData.map((oneEmailAddress, key) =>
                            <Tr className="centered" key={oneEmailAddress.uniqueId.value} id={oneEmailAddress.uniqueId.value}>
                                <Td column="email.value">{oneEmailAddress.email.value}</Td>
                                <Td column="default.value">
                                    <input
                                        type="radio"
                                        value={oneEmailAddress.default.value}
                                        checked={oneEmailAddress.default.checked}
                                        name={"emailAddresses"}
                                        onBlur={(e)=>{ return false }}
                                        onChange={(value) => {
                                            return this.setCheckedAndClearOthers(oneEmailAddress.uniqueId, newData)
                                        }}
                                    />
                                </Td>
                                <Td column="checkEmail">
                                    <button
                                        type="button"
                                        className={styles.removeFieldsButton}
                                        onClick={event => {
                                            event.preventDefault()

                                            // prevent to delete the default phone number
                                            if ((isSetDefaultValue && oneEmailAddress.default.checked || !isSetDefaultValue)) {
                                                return this.setState({informModalOpen: true})
                                            }

                                            this.removeItemFromList(oneEmailAddress.uniqueId.value)
                                    }}>
                                        <img src={this.getIcon()}/>
                                    </button>
                                </Td>
                            </Tr>
                        )
                        }
                    </Table>
                    }

                    {formStatus != undefined && formStatus.emailDefault == true &&
                    < div className={ styles.error }> { _('requiredDefaultEmail') } </div>}

                    <button type="button"
                            className={styles.addFieldButton}
                            onClick={() => {
                                const {data} = this.props
                                this.handleAddFieldButton()
                            }}>+
                    </button>
                </div>
                <Modal
                    isOpen={modalIsOpen}
                    style={customStyles}
                    contentLabel="Modal"
                >
                    {this.modalContentPopup()}
                </Modal>
                <InfoModal
                    isOpen={Boolean(informModalOpen)}
                    title={_("infoModalEmailAddressCanNotDeleteTitle")}
                    content={_("infoModalEmailAddressCanNotDeleteDescription")}
                    onCancel={()=>{}}
                    onConfirmation={()=>{return this.setState({informModalOpen: false})}}
                    cancelLabel={_("cancel")}
                    confirmationLabel={_("ok")}
                    options={{noCancelButton: true}}
                />
            </div>


        )
    }
}



// WEBPACK FOOTER //
// ./components/emailListSelect.jsx